import { Button } from "@shared/src/components/ui/button";
import { cn } from "@shared/src/utils/cn";
import Link from "next/link";

export default function ViewDetailsButton({
  className,
  href,
  onClick,
}: {
  className?: string;
  href: string;
  onClick?: () => void;
}) {
  return (
    <Button
      asChild
      variant="surface-tertiary"
      radius="full"
      className={cn("font-medium !h-12 px-4 md:px-6 py-2.5", className)}
    >
      <Link href={href} onClick={onClick}>
        View Details
      </Link>
    </Button>
  );
}
